import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../../hocs/deviceDOMHoc';
import AggScale from './AggScale';
import CemScale from './CemScale';
import WaterScale from './WaterScale';
import { WeighedMaterialType } from '../../../constants/MaterialModels';
import { OUTPUT_TTL } from '../../../constants/Pac';
import Decum from './Decum';

@inject('devicesStore', 'batchStore', 'materialStore', 'settingsStore')
@observer
class Scale extends Component {
  onOpen = (openPort, closePort) => {
    const { batchStore } = this.props;

    if (openPort) {
      batchStore.setOutput(openPort, OUTPUT_TTL);
    }

    if (closePort) {
      batchStore.setOutput(closePort, '0');
    }
  };

  onClose = (closePort, openPort) => {
    const { batchStore } = this.props;

    if (closePort) {
      batchStore.setOutput(closePort, OUTPUT_TTL);
    }

    if (openPort) {
      batchStore.setOutput(openPort, '0');
    }
  };

  render() {
    const { device, devicesStore } = this.props;
    const materialType = devicesStore.getMaterialTypeForScale(device);

    if (device.decumulative) {
      return <Decum {...this.props} onOpen={this.onOpen} onClose={this.onClose}/>;
    }

    if (materialType === WeighedMaterialType.FineAggregate || materialType === WeighedMaterialType.CoarseAggregate) {
      return <AggScale {...this.props} onOpen={this.onOpen} onClose={this.onClose} />;
    }

    if (materialType === WeighedMaterialType.Water || materialType === WeighedMaterialType.SecondWater) {
      return <WaterScale {...this.props} onOpen={this.onOpen} onClose={this.onClose} />;
    }

    return <CemScale {...this.props} onOpen={this.onOpen} onClose={this.onClose} />;
  }
}

export default deviceDOMHoc(Scale);
